import { z } from 'zod';
/**
 * Flag-key grammar (Appendix B): lowercase letter prefix, lowercase
 * letters / digits / dashes only, 3..64 chars. Single source of truth —
 * both the entity row schema below and the create/update body in
 * `endpoints/flags.ts` import this so the route-level dedupe regex never
 * drifts from the persisted shape. Mirrors the `teamSlugSchema` pattern
 * in `schemas/team.ts`.
 */
export const flagKeySchema = z
    .string()
    .min(3)
    .max(64)
    .regex(/^[a-z][a-z0-9-]*$/, 'flag key must match ^[a-z][a-z0-9-]*$');
/**
 * In-DB feature flag. Spec §4.1, §6.2, Appendix B. Targeting rules are a
 * free-form JSONB blob — shape documented per-flag in Appendix B.
 */
export const featureFlagTargetingSchema = z
    .object({
    teamIds: z.array(z.string().uuid()).optional(),
    userIds: z.array(z.string().uuid()).optional(),
    rolloutPct: z.number().int().min(0).max(100).optional(),
})
    .catchall(z.unknown());
export const featureFlagSchema = z.object({
    key: flagKeySchema.describe('Feature-flag key (Appendix B grammar).'),
    description: z.string().nullable(),
    enabled: z.boolean(),
    targetingRules: featureFlagTargetingSchema.nullable(),
    /** Flag-associated config; null for pure on/off flags. Spec §4.3. */
    value: z.unknown().nullable(),
    updatedBy: z.string().uuid().nullable(),
    updatedAt: z.string().datetime(),
});
/** Evaluated flag shape emitted by `GET /flags/evaluate`. */
export const flagEvaluationSchema = z.object({
    key: z.string(),
    enabled: z.boolean(),
    value: z.unknown().nullable(),
});
//# sourceMappingURL=feature-flag.js.map